import { render, staticRenderFns } from "./VideoCustom.vue?vue&type=template&id=620d0088&scoped=true&"
import script from "./VideoCustom.vue?vue&type=script&lang=js&"
export * from "./VideoCustom.vue?vue&type=script&lang=js&"
import style0 from "./VideoCustom.vue?vue&type=style&index=0&id=620d0088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d0088",
  null
  
)

export default component.exports